import { render } from "./AgreementList.vue?vue&type=template&id=5141a2fa&scoped=true"
import script from "./AgreementList.vue?vue&type=script&steup=true&lang=js"
export * from "./AgreementList.vue?vue&type=script&steup=true&lang=js"

import "./AgreementList.vue?vue&type=style&index=0&id=5141a2fa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5141a2fa"]])

export default __exports__